import React, { useState } from 'react';
import './VerComandos.css';
import Comandos from './Comandos';
import ComandosHistoricos from './ComandosHistoricos';
import { Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function VerComandos(){
    const { t } = useTranslation();
    sessionStorage.setItem("screen","comandos");

    var [code, setCode] = useState(null);
    if(code == null) {
        let valor = parseInt(sessionStorage.getItem('key')) + 1;
        setCode(valor);
        sessionStorage.setItem("key", valor)
    }
    return (
        <div className="div-tabs-comandos">
            <Tabs defaultActiveKey="Comandos">
                <Tab eventKey="Comandos" title={t('scada.solarFarm.commands.commands')}>
                    <Comandos/>
                </Tab>
                <Tab eventKey="Históricos" title={t('scada.solarFarm.commands.historical')}>
                    <ComandosHistoricos code={code}/>
                </Tab>
            </Tabs>
        </div>
    );
};

export default VerComandos;